<template>
  <LegalDocumentPage
    document-type="terms_of_service"
    fallback-title-key="footer.termsOfService"
  />
</template>

<script setup>
import LegalDocumentPage from '../components/legal/LegalDocumentPage.vue';
</script>
